import React from "react";
import  {CertificationGroup } from "../componets/CertificationGroup";
import '../pages/Certifications.css';
import {CoursesGroup} from "../componets/CoursesGroup";

import { Fotter } from "../componets/Fotter";

export const Certifications = () => {
  return (
    <>
 
    <div className="certificat">
   <CertificationGroup/>
     <CoursesGroup/>
    </div>
    <Fotter/>
    </>
  );
};
